var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-message",class:_vm.classes},[_c('icon',{staticClass:"ui-message__icon",attrs:{"type":"info"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }